/**
 * Small, unobtrusive Suspense fallback shown while a lazy route chunk
 * loads (see React.lazy in App.js). Usually visible for a split second.
 */
const RouteFallback = () => (
  <div className="min-h-[40vh] flex items-center justify-center" role="status" aria-label="Loading" data-testid="route-fallback">
    <div className="animate-spin rounded-full h-6 w-6 border-2 border-wine-200 border-t-wine-600" />
  </div>
);

export default RouteFallback;
